import { createApp } from 'vue'
import Notifications from '@kyvg/vue3-notification'
import bootstrap from 'bootstrap/js/index.umd'
import router from './router'
import App from './App.vue'
import i18n from './i18n'

import API from './api'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './assets/admin-design.css'
// import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App)

window.bootstrap = bootstrap
app.config.globalProperties.$api = API

router.beforeEach(async (to, from, next) => {
    let auth = await getAuth()
    let user = await getUser()

    if(auth && to.path.startsWith('/login')) {
        next('/cabinet')
    }
    
    if(to.matched.some(r => r.meta.isCabinet)) {
        if(!auth) {
            next({ path: '/login' })
        } else {
            let roles = []
            to.matched.forEach(i => {
                if(i.meta.roles) roles.push(...i.meta.roles)
            })

            if(!roles.includes(user.role)) {
                next({ path: '/cabinet' })
            } else {
                next()
            }
        }
    } else {
        next()
    }
})

app.use(Notifications)
app.use(bootstrap)
app.use(router)
app.use(i18n)

app.mount('#app')

async function getUser() {
    let r = await fetch(process.env.VUE_APP_API_URL + '/auth/role', {
        method: 'GET',
        credentials: 'include'
    })
    r = await r.json()
    return r.data
}

async function getAuth() {
    let auth = false

    let r = await fetch(process.env.VUE_APP_API_URL + '/auth/session', {
        method: 'GET',
        credentials: 'include'
    })
    r = await r.json()

    if(r) {
        auth = {
            status: r.data ?? false
        }
    }

    return auth ? auth.status : false
}